import { inject, Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { EMPTY, Observable, catchError, tap } from 'rxjs';
import { LoadLoginStatus } from '@core/login-status/store/actions/login-status.actions';
import { LoginStatusResponse } from '@core/login-status/models/login-status-response.interface';
import { LoginStatusService } from '@core/login-status/services/login-status.service';

interface LoginStatusStateModel {
  isLoginDegradationBannerEnabled: boolean;
}

@State<LoginStatusStateModel>({
  name: 'loginStatus',
  defaults: {
    isLoginDegradationBannerEnabled: false,
  },
})
@Injectable()
export class LoginStatusState {
  private readonly loginStatusService = inject(LoginStatusService);

  @Selector()
  static isLoginDegradationBannerEnabled(state: LoginStatusStateModel): boolean {
    return state.isLoginDegradationBannerEnabled;
  }

  @Action(LoadLoginStatus, { cancelUncompleted: true })
  loadLoginStatus(context: StateContext<LoginStatusStateModel>): Observable<LoginStatusResponse> {
    return this.loginStatusService.getLoginStatus().pipe(
      tap(({ isLoginDegradationBannerEnabled }) => context.patchState({ isLoginDegradationBannerEnabled })),
      catchError(() => {
        context.patchState({ isLoginDegradationBannerEnabled: false });
        return EMPTY;
      })
    );
  }
}
